export default __webpack_public_path__ + "static/media/top-logo.3133543f.png";